import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../message";
import blockContactsService from "../../../services/blockContacts";
import {toast} from "react-toastify"

export const createBlockContact = createAsyncThunk(
  "blockContacts/createBlockContact",
  async (payload, thunkAPI) => {
    try {
        console.log('create block recipient thunk calling....')
      const result = await blockContactsService.createBlockContact(
        payload
      );
      if (!result?.data?.error) {

        toast.success("block recipient created successfully.")
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result.data.message));
        toast.error(result.data.message)
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateBlockContact = createAsyncThunk(
  "blockContacts/updateBlockContact",
  async (payload , thunkAPI) => {
    try {
      console.log('updating block recipient data from thunk function ', payload)
      const result = await blockContactsService.updateBlockContact(
        payload
      );
      if (!result?.data?.error) {
        
        toast.success("Block contact updated successfully.")
        return result;

      } else {
        thunkAPI.dispatch(setMessage(result.data.message));
        toast.error(result.data.message)
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const bulkUploadGlobalBlockContact = createAsyncThunk(
  "blockContacts/bulkUploadGlobalBlockContact",
  async (formData, thunkAPI) => {
    try {
      const result = await blockContactsService.bulkUploadGlobalBlockContact(
        formData
      );
      if (result?.success) {
        toast.success(result.message);
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result?.message));
        toast.error(result?.message || "Bulk upload failed.");
        return thunkAPI.rejectWithValue(result);
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      toast.error(message);
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  blockContact: null,
  refreshBlockContact:false,
  bulkUploading:false,
  bulkUploadResult:null
};

const blockContactCreatetSlice = createSlice({
  name: "blockContactcreate",
  initialState,
  reducers:{
    reSetBlockContact(state, _){
      state.blockContact = null
    },
    resetBulkUploadResult(state, _){
      state.bulkUploadResult = null
    }
  },
  extraReducers: {
    [createBlockContact.fulfilled]: (state, action) => {
      console.log("createBlockContact.fulfilled...", action.payload);
      state.blockContact=action.payload;
      state.refreshBlockContact = !state.refreshBlockContact;
    },
    [createBlockContact.rejected]: (state, action) => {
      state.blockContact = null;
    },
    [updateBlockContact.fulfilled]: (state, action) => {
      console.log("updateBlockContact.fulfilled okkkkkkkkkk", action);
      state.blockContact=action.payload;
      state.refreshBlockContact = !state.refreshBlockContact;
    },
    [updateBlockContact.rejected]: (_, action) => {
      //state.campaign = null;
      console.log("updateBlockContact.rejected okkkkkkkkkk", action);
    },
    [bulkUploadGlobalBlockContact.pending]: (state) => {
      state.bulkUploading = true;
      state.bulkUploadResult = null;
    },
    [bulkUploadGlobalBlockContact.fulfilled]: (state, action) => {
      state.bulkUploading = false;
      state.bulkUploadResult = action.payload;
      state.refreshBlockContact = !state.refreshBlockContact;
    },
    [bulkUploadGlobalBlockContact.rejected]: (state, action) => {
      state.bulkUploading = false;
      state.bulkUploadResult = action.payload || null;
    }
  },
});

export const { reSetBlockContact, resetBulkUploadResult } = blockContactCreatetSlice.actions;

export default blockContactCreatetSlice.reducer;
